import { CropModalContextProvider } from './context/crop-modal-context-provider'
import { CropModalInner } from './components/crop-modal-inner'

/**
 * Modal for creating or editing a crop.
 *
 * @param {string} cropId if passed modal will be in EDIT mode for this crop
 * @param {boolean} open
 * @param {function} onClose
 */
export const CropModal = ({ cropId, open, onClose }) => (
  <CropModalContextProvider cropId={cropId} open={open} onClose={onClose}>
    <CropModalInner />
  </CropModalContextProvider>
)
